import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { MaskedLines, Reveal } from "@/components/site/Reveal";
import { BuyButton } from "@/components/site/BuyButton";
import { useShop } from "@/lib/shop";
import { track } from "@/lib/track";
import { useSeo } from "@/lib/useSeo";

export default function ThankYou() {
  const { products, priceOf } = useShop();
  const wb = products.workbook;
  useSeo("Thank you");
  useEffect(() => { track("view_upsell", { content_name: wb.name }); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <main data-testid="thank-you-page" className="pt-28 md:pt-36">
      <section className="mx-auto max-w-7xl px-6 md:px-12">
        <p className="eyebrow flex items-center gap-2"><Check size={14} className="text-white" /> Order confirmed</p>
        <h1 className="font-display mt-6 text-5xl font-medium leading-[1.02] tracking-tight text-white md:text-7xl">
          <MaskedLines lines={["Your eBook is on its way.", <span key="l" className="font-serif-i text-zinc-400">One more thing.</span>]} />
        </h1>
        <p className="mt-6 max-w-xl text-zinc-300">Check your inbox for the download link. Before you start reading, one honest recommendation:</p>
      </section>
      <section className="mx-auto max-w-7xl px-6 py-20 md:px-12">
        <Reveal>
          <div data-testid="upsell-card" className="grid overflow-hidden border border-cta bg-[#0a0f1f] md:grid-cols-2">
            <img src={wb.image} alt={wb.name} className="aspect-[4/3] h-full w-full object-cover" />
            <div className="p-8 md:p-12">
              <p className="eyebrow">Add the Workbook</p>
              <h2 className="font-display mt-4 text-3xl font-medium tracking-tight text-white md:text-4xl">Readers who apply it, move faster.</h2>
              <p className="mt-5 text-zinc-300">{wb.tagline}</p>
              <ul className="mt-6 space-y-2">
                {wb.includes.slice(0, 3).map((i) => <li key={i} className="flex gap-3 text-sm text-zinc-300"><Check size={16} className="mt-0.5 shrink-0" />{i}</li>)}
              </ul>
              <p className="font-display mt-8 text-4xl font-semibold text-white">{priceOf("workbook")}</p>
              <BuyButton role="workbook" testId="upsell-buy-button" className="mt-6 w-full">Add the Workbook</BuyButton>
              <Link to="/" data-testid="upsell-decline-link" className="mt-5 block text-center text-sm text-zinc-400 hover:text-white">No thanks, I will start with the eBook</Link>
            </div>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
